module.exports = "/assets/9fa4c9149908c3b85424225189626dfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/LX.png
// module id = 2719
// module chunks = 0